import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { TrinoDataset } from 'app/model/dataset/trino.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(TrinoDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class TrinoDatasetAdapter extends TabularTypeDatasetAdapter<TrinoDataset, Model.DatasetResource> {
    protected async _toResource(dataset: TrinoDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(TrinoDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: TrinoDataset): Promise<TrinoDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, TrinoDataset.MODEL);
    }
}
